
<script>
  import Carousel from 'scripts/components/basic/Carousel.vue';
  import Slide from 'scripts/components/basic/Slide.vue';
  import SubscriptionStep from 'scripts/components/basic/SubscriptionStep.vue';

  export default {
    name: 'coffeeType',
    components: { Carousel, Slide, SubscriptionStep },
    inject: ['chooseCoffeeType'],
    template: '#step2',
    props: [
      'currentStep',
      'step1',
      'step2'
    ],
    methods: {
      proceedToNext(step) {
        this.$router.push('/step2');
      },
    },
  };

</script>